<ng-container [formGroup]="warehouseForm">
    <h4
        mat-dialog-title
        *ngIf="!data.id"
        i18n="@@c0f576cb01c6f1fea50d64e6f9ce2d550a5ea09b"
        t="c0f576cb01c6f1fea50d64e6f9ce2d550a5ea09b"
        >Add Warehouse</h4
    >
    <h4
        mat-dialog-title
        *ngIf="data.id"
        i18n="@@c977f0e8c5f1b65fa996f090092aba873cf131bb"
        t="c977f0e8c5f1b65fa996f090092aba873cf131bb"
        >Update Warehouse</h4
    >

    <div class="grid">
        <div class="row">
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label
                        i18n="@@ed31c09fd77c36238c13d83635f3fe5294c733d2"
                        t="ed31c09fd77c36238c13d83635f3fe5294c733d2"
                        >Location</tsl-label
                    >
                    <input
                        id="location"
                        required
                        tslInput
                        fullWidth
                        maxlength="75"
                        shape="rectangle"
                        formControlName="location"
                    />
                    <tsl-error *ngIf="location.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="50">
                <tsl-form-field fxFlex="95">
                    <tsl-label i18n="@@Address" t="Address">Address</tsl-label>
                    <input
                        id="address"
                        required
                        tslInput
                        fullWidth
                        maxlength="100"
                        shape="rectangle"
                        formControlName="address"
                    />
                    <tsl-error *ngIf="address.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>
        <div class="row">
            <div fxFlex="25">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@City" t="City">City</tsl-label>
                    <input
                        id="city"
                        required
                        tslInput
                        fullWidth
                        maxlength="50"
                        shape="rectangle"
                        formControlName="city"
                    />
                    <tsl-error *ngIf="city.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="25">
                <tsl-form-field fxFlex="90">
                    <tsl-label
                        i18n="@@873b72903b1858a9cd6c8967521030b4d7d1435b"
                        t="873b72903b1858a9cd6c8967521030b4d7d1435b"
                        >State</tsl-label
                    >
                    <input
                        id="state"
                        required
                        tslInput
                        fullWidth
                        maxlength="50"
                        shape="rectangle"
                        formControlName="state"
                    />
                    <tsl-error *ngIf="state.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="25">
                <tsl-form-field fxFlex="90">
                    <tsl-label
                        i18n="@@73f71f6be8e257467172f45a9e44934f979074e7"
                        t="73f71f6be8e257467172f45a9e44934f979074e7"
                        >Zip/Postal Code</tsl-label
                    >
                    <input
                        id="zipcode"
                        required
                        tslInput
                        type="number"
                        fullWidth
                        maxlength="15"
                        shape="rectangle"
                        formControlName="zipcode"
                    />
                    <tsl-error *ngIf="zipcode.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
            <div fxFlex="25">
                <tsl-form-field fxFlex="90">
                    <tsl-label i18n="@@Country" t="Country">Country</tsl-label>
                    <input
                        id="country"
                        required
                        tslInput
                        fullWidth
                        maxlength="20"
                        shape="rectangle"
                        formControlName="country"
                    />
                    <tsl-error *ngIf="country.invalid" i18n="@@Required" t="Required">Required</tsl-error>
                </tsl-form-field>
            </div>
        </div>
    </div>

    <div class="right">
        <button tsl-button size="small" color="black" outline (click)="onClose()" i18n="@@Cancel" t="Cancel"
            >Cancel</button
        >
        <button tsl-button size="small" color="blue" filled [disabled]="warehouseForm.invalid" (click)="onSave()" i18n
            >Save</button
        >
    </div>
</ng-container>
